import { Row, Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

const GuideLayoutStyles = css`
  width: 100%;
  max-width: 1092px;
  padding: ${getSpacing(0, "3x")};

  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing(0, "5x")};
  }
`;

export const GuideRowSection = styled(Row)`
  ${GuideLayoutStyles}
`;

export const GuideColumnSection = styled(Column)`
  ${GuideLayoutStyles}
`;
